import { Typography } from '@mui/material';
import React from 'react';

function EmphasizableCaption(props: {
  children: React.ReactNode;
  hasError: boolean;
}) {
  const { children, hasError } = props;

  return (
    <Typography
      variant="caption"
      color={hasError ? 'error' : undefined}
      style={{
        display: 'inline-block',
        transition: 'all 100ms ease',
        transform: hasError ? 'scale(1.1)' : undefined,
        transformOrigin: '0 0',
      }}
    >
      {children}
    </Typography>
  );
}
export default EmphasizableCaption;
